import { Star, Shield, Award, CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const MiniTestimonials = () => {
  const testimonials = [
    {
      name: "Sarah M.",
      location: "Bethel, CT",
      rating: 5,
      text: "The estimate process was so easy! The video call was quick and they gave me an accurate quote right away. Highly professional service."
    },
    {
      name: "Mike R.",
      location: "Ridgefield, CT", 
      rating: 5,
      text: "Got my estimate the same day I submitted the request. The team was thorough in understanding my commercial space needs."
    },
    {
      name: "Jennifer L.",
      location: "Stamford, CT",
      rating: 5,
      text: "Free estimate, no pressure, and very detailed breakdown of services. They answered all my questions during the consultation."
    }
  ];

  const trustBadges = [
    {
      icon: Shield,
      label: "Fully Insured & Bonded",
      description: "Complete protection for your property"
    },
    {
      icon: Star,
      label: "5-Star Rated",
      description: "Based on 500+ customer reviews"
    },
    {
      icon: Award,
      label: "Satisfaction Guaranteed",
      description: "100% money-back guarantee"
    },
    {
      icon: CheckCircle,
      label: "Background Checked",
      description: "All team members verified"
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        {/* Testimonials */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            What Our <span className="bg-gradient-to-r from-brand-gold-dark to-brand-gold-light bg-clip-text text-transparent">Customers</span> Say
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Hear from satisfied customers who experienced our seamless estimate process.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="h-full">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-brand-gold-dark text-brand-gold-dark" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-4 text-sm leading-relaxed">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mr-3">
                    <span className="text-xs font-semibold text-primary">{testimonial.name.split(' ').map(n => n[0]).join('')}</span>
                  </div>
                  <div>
                    <div className="font-medium text-sm">{testimonial.name}</div>
                    <div className="text-xs text-muted-foreground">{testimonial.location}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        {/* Trust Badges */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {trustBadges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-primary/5 rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm">
                  <Icon className="w-6 h-6 text-accent" />
                </div>
                <h3 className="font-semibold text-sm mb-1">{badge.label}</h3>
                <p className="text-xs text-muted-foreground">{badge.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MiniTestimonials;